import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextosService {


  public static NombreAsig: string = "/ UAC";
  // public static NombreAsig: string = "";
  public static NombreAsig1: string = "UAC";
  public static ESTUDIANTES: string = "ESTUDIANTES";
  public static estudiante: string = "estudiantes";





  constructor() { }
}
